import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NetworkSpeedService {
  private networkSpeedSource = new BehaviorSubject<string>('online');
  public networkSpeed$ = this.networkSpeedSource.asObservable();

  constructor() {
    this.updateNetworkSpeed();

    // Listen to network changes
    fromEvent(window, 'online').subscribe(() => this.updateNetworkSpeed());
    fromEvent(window, 'offline').subscribe(() => this.updateNetworkSpeed());

    // Listen to network connection changes if the API is available
    if ((navigator as any).connection) {
      (navigator as any).connection.addEventListener('change', () =>
        this.updateNetworkSpeed()
      );
    }
  }

  private updateNetworkSpeed(): void {
    if (navigator.onLine) {
      this.networkSpeedSource.next('online');
    } else {
      this.networkSpeedSource.next('offline');
    }
  }
}
